// What each code-map mode shows and what it's for (the Orbital design's wording),
// shared by the global map and the ticket's map so both explain the same thing.
import type { MapMode } from "@/components/map/CodeMap.vue";

export const MODE_HELP: Record<MapMode, { label: string; what: string; use: string }> = {
  structure: { label: "Structure", what: "How the code is organized: repositories, packages, modules and symbols, with their connections.", use: "Learn an unfamiliar codebase and find where a feature belongs." },
  flow: { label: "Data flow", what: "The direction of requests, events and data between connected parts of the system. Only edges that carry data at runtime move; static links stay still.", use: "Trace a user action end to end and find where a flow may break." },
  tickets: { label: "Tickets", what: "One Jira ticket's code footprint across all its agent runs and attempts.", use: "Connect the original request to the code being investigated or changed." },
  hotspots: { label: "Hotspots", what: "Code with many dependents. Larger nodes mean more of the system relies on them.", use: "Prioritize review and tests around highly connected code. Size is dependency reach, not a defect prediction." },
  blast: { label: "Blast radius", what: "What depends on the selected node, directly and through further connections. Farther dependents fade.", use: "Before a change, find the affected areas and plan regression tests. Reach does not mean something will break." },
  activity: { label: "Activity", what: "Where agents read, edited or probed code during the period.", use: "Follow agent work, spot repeated investigation and see which areas got attention." },
};

export function modeTitle(m: MapMode): string {
  const h = MODE_HELP[m];
  return `${h.what} ${h.use}`;
}

// The granularity control's stops, coarsest first: the map shows down to this level.
export const DETAIL_LABELS = ["Repos", "Packages", "Modules", "Symbols"] as const;
export const DETAIL_HELP = [
  "Repositories and what connects them, rolled up.",
  "Packages and the links between them.",
  "Modules (files) and their imports, calls and flows.",
  "Every indexed symbol: functions, classes and methods.",
] as const;
